// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2322":"860b5ab1","2556":"6f39f5b9","4180":"c07e5186","4227":"e78bc5e2","4546":"c1fdf22e","4969":"196bf7b1","8649":"14ecb0d0","8786":"c07e5186"}[chunkId] + ".chunk.css";
};